import React, { useState, useEffect } from 'react';
import { Truck, Plus, Search, Phone, CreditCard, Hash, Eye, EyeOff, X, AlertCircle, Pencil, Trash2,FileSpreadsheet } from 'lucide-react';
import api from '../../api/axios'; // Asegúrate de tener axios instalado
const DriversPage = () => {
    // 1. ESTADOS
    const [drivers, setDrivers] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [editingDriver, setEditingDriver] = useState(null);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        license_number: '',
        vehicle_plate: '',
        password: '',
        password_confirmation: ''
    });

    // 2. CARGAR DATOS DEL BACKEND
const fetchDrivers = async () => {
    try {
        const response = await api.get('/drivers');
        const raw = response.data?.data || response.data;
        setDrivers(Array.isArray(raw) ? raw : []);
    } catch (error) {
        console.error("Error al obtener choferes:", error);
        setDrivers([]);
    }
};

    useEffect(() => { fetchDrivers(); }, []);

    // 4. Submit unificado (POST o PUT)
const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Creamos una copia limpia
    const dataToSend = { ...formData };

    // Limpieza: Si no hay contraseña nueva, eliminamos ambos campos
    if (!dataToSend.password || dataToSend.password.trim() === "") {
        delete dataToSend.password;
        delete dataToSend.password_confirmation;
    }

    try {
        if (editingDriver) {
            await api.put(`/drivers/${editingDriver.id}`, dataToSend);
            alert("✅ Chofer actualizado con éxito");
        } else {
            await api.post('/drivers', dataToSend);
            alert("✅ Chofer registrado con éxito");
        }
        
        setIsModalOpen(false);
        setEditingDriver(null);
        fetchDrivers();
        setFormData({ name: '', email: '', phone: '', license_number: '', vehicle_plate: '', password: '', password_confirmation: '' });
    } catch (error) {
        // Esto mostrará el error específico que te envíe Laravel (422)
        const errorMessage = error.response?.data?.message || "Ocurrió un fallo en el servidor";
        const validationErrors = error.response?.data?.errors;
        
        let displayError = errorMessage;
        if (validationErrors) {
            // Si Laravel envía errores detallados, los mostramos
            const firstError = Object.values(validationErrors)[0][0];
            displayError = firstError;
        }
        alert("Error: " + displayError);
    } finally {
        setLoading(false);
    }
};

    // 4. FILTRADO PARA LA BUSQUEDA
    const filteredDrivers = drivers.filter(d => 
        d.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
        d.vehicle_plate.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const handleEditClick = (driver) => {
    setEditingDriver(driver);
    setFormData({
        name: driver.name,
        email: driver.email,
        phone: driver.phone,
        license_number: driver.license_number,
        vehicle_plate: driver.vehicle_plate,
        password: '' // Dejar vacío por seguridad al editar
    });
    setIsModalOpen(true);
};
// 3. Función para eliminar
const handleDelete = async (id) => {
    if (!window.confirm("¿Estás seguro de dar de baja a este chofer de la flota?")) return;
    
    try {
        await api.delete(`/drivers/${id}`);
        fetchDrivers();
        alert("🗑️ Chofer eliminado correctamente");
    } catch (error) {
        alert("Error al eliminar chofer");
    }
};

const handleExportAll = async () => {
    try {
        // Llamada a la nueva ruta única
        const response = await api.get('/export/all-in-one', {
            responseType: 'blob' // Es vital para descargar archivos
        });

        // Crear el link de descarga
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8;' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Reporte_Completo_TBT.csv'); 
        document.body.appendChild(link);
        link.click();
        
        // Limpieza
        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error al exportar:", error);
        alert("❌ No se pudo generar el reporte consolidado.");
    }
};
    return (
        <div className="space-y-6">
            {/* CABECERA Y BUSCADOR */}
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div>
                    <h3 className="text-3xl font-black mb-1 uppercase tracking-tighter text-[#CE010B] dark:text-white">
                        Gestión de Choferes
                    </h3>
                    <p className="text-gray-500 dark:text-white/60 font-medium text-sm italic">
                        Control de flota y operadores activos.
                    </p>
                </div>

                <div className="flex items-center gap-3">
                    <div className="relative group">
                        <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-[#CE010B] transition-colors" size={18} />
                        <input 
                            type="text"
                            placeholder="Buscar por nombre o placa..."
                            className="pl-12 pr-6 py-3.5 w-64 rounded-2xl bg-white dark:bg-black/20 border-none outline-none ring-1 ring-black/5 dark:ring-white/10 focus:ring-2 focus:ring-[#CE010B] transition-all font-bold text-sm"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    {/* 🟢 NUEVO BOTÓN DE EXPORTAR (Estilo igualado al de Nuevo Chofer) 🟢 */}
                    <button 
                        onClick={handleExportAll}
                        className="flex items-center gap-2 bg-emerald-600 text-white px-6 py-3.5 rounded-2xl font-black uppercase text-[10px] tracking-widest hover:scale-105 hover:shadow-lg active:scale-95 transition-all shadow-emerald-600/20"
                    >
                        <FileSpreadsheet size={18} /> Exportar Reporte 
                    </button>
                    <button 
    onClick={() => {
        // 1. Limpiamos el chofer en edición para decirle a React que es uno nuevo
        setEditingDriver(null); 
        // 2. Vaciamos los campos del formulario
        setFormData({
            name: '',
            email: '',
            phone: '',
            license_number: '',
            vehicle_plate: '',
            password: ''
        });
        // 3. Abrimos el modal
        setIsModalOpen(true);
    }}
    className="flex items-center gap-2 bg-[#CE010B] text-white px-6 py-3.5 rounded-2xl font-black uppercase text-[10px] tracking-widest hover:scale-105 hover:shadow-lg active:scale-95 transition-all"
>
    <Plus size={18} /> Nuevo Chofer
</button>
                </div>
            </div>

            {/* TABLA DE CHOFERES */}
            <div className="bg-white dark:bg-black/40 rounded-[2.5rem] border border-black/5 dark:border-white/10 shadow-sm overflow-hidden">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-gray-50/50 dark:bg-white/5 border-b border-black/5 dark:border-white/10">
                            <th className="py-5 px-8 text-[10px] uppercase font-black text-gray-400 tracking-widest">Identidad del Chofer</th>
                            <th className="py-5 px-8 text-[10px] uppercase font-black text-gray-400 tracking-widest text-center">Licencia</th>
                            <th className="py-5 px-8 text-[10px] uppercase font-black text-gray-400 tracking-widest text-center">Unidad (Placas)</th>
                            <th className="py-5 px-8 text-[10px] uppercase font-black text-gray-400 tracking-widest text-right">Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-black/5 dark:divide-white/5">
                        {filteredDrivers.length > 0 ? filteredDrivers.map((driver) => (
                            <tr key={driver.id} className="group hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
                                <td className="py-5 px-8">
                                    <div className="flex items-center gap-4">
                                        <div className="w-10 h-10 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center text-[#CE010B] font-black">
                                            {driver.name.charAt(0)}
                                        </div>
                                        <div>
                                            <p className="font-bold text-gray-800 dark:text-white uppercase text-sm">{driver.name}</p>
                                            <p className="text-[10px] text-gray-400 font-bold uppercase">{driver.email}</p>
                                        </div>
                                    </div>
                                </td>
                                <td className="py-5 px-8 text-center">
                                    <span className="font-mono text-xs font-bold bg-black/5 dark:bg-white/10 px-3 py-1.5 rounded-lg text-gray-600 dark:text-white/80 border border-black/5 dark:border-white/10">
                                        {driver.license_number}
                                    </span>
                                </td>
                                <td className="py-5 px-8 text-center">
                                    <span className="font-black text-[#CE010B] tracking-wider text-sm">
                                        {driver.vehicle_plate}
                                    </span>
                                </td>
                                <td className="py-5 px-8 text-right">
                                    <div className="flex justify-end gap-2">
                                        {/* Botón de Editar */}
                                        <button 
                                            onClick={() => handleEditClick(driver)}
                                            className="p-2.5 bg-blue-50 dark:bg-blue-500/10 text-blue-600 dark:text-blue-400 hover:bg-blue-600 hover:text-white rounded-xl transition-all shadow-sm"
                                            title="Editar información"
                                        >
                                            <Pencil size={16} />
                                        </button>

                                        {/* Botón de Eliminar */}
                                        <button 
                                            onClick={() => handleDelete(driver.id)}
                                            className="p-2.5 bg-red-50 dark:bg-red-500/10 text-red-600 dark:text-red-400 hover:bg-red-600 hover:text-white rounded-xl transition-all shadow-sm"
                                            title="Dar de baja"
                                        >
                                            <Trash2 size={16} />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan="4" className="py-20 text-center text-gray-400 font-bold uppercase text-[10px] tracking-widest italic">
                                    No se encontraron choferes registrados.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* MODAL DE REGISTRO / EDICIÓN (REUTILIZANDO ESTILO TBT) */}
            {isModalOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                    {/* Overlay con desenfoque */}
                    <div 
                        className="absolute inset-0 bg-black/60 backdrop-blur-sm" 
                        onClick={() => !loading && setIsModalOpen(false)}
                    ></div>
                    
                    <form 
                        onSubmit={handleSubmit} 
                        className="relative w-full max-w-xl bg-white dark:bg-[#1A1A1A] rounded-[3rem] p-10 shadow-2xl border border-white/20 overflow-hidden"
                    >
                        {/* Header del Modal Dinámico */}
                        <div className="flex justify-between items-center mb-8">
                            <div>
                                <h4 className="text-2xl font-black text-[#CE010B] uppercase tracking-tighter">
                                    {editingDriver ? 'Actualizar Unidad' : 'Alta de Unidad'}
                                </h4>
                                <p className="text-xs text-gray-400 font-bold uppercase">
                                    {editingDriver ? `Editando a: ${editingDriver.name}` : 'Registro de nuevo operador logístico'}
                                </p>
                            </div>
                            <button 
                                type="button" 
                                onClick={() => setIsModalOpen(false)} 
                                className="p-2 hover:bg-gray-100 dark:hover:bg-white/10 rounded-full transition-all"
                            >
                                <X size={20} className="text-gray-400" />
                            </button>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                            {/* Nombre */}
                            <div className="col-span-2 space-y-1">
                                <label className="text-[10px] font-black uppercase text-gray-400 px-1">Nombre del Operador</label>
                                <input 
                                    required 
                                    className="w-full p-4 rounded-2xl bg-gray-50 dark:bg-white/5 border-none outline-none focus:ring-2 focus:ring-[#CE010B] font-bold" 
                                    value={formData.name} 
                                    onChange={e => setFormData({...formData, name: e.target.value})} 
                                />
                            </div>
                            
                            {/* Email */}
                            <div className="space-y-1">
                                <label className="text-[10px] font-black uppercase text-gray-400 px-1">Correo Electrónico</label>
                                <input 
                                    type="email" 
                                    required 
                                    className="w-full p-4 rounded-2xl bg-gray-50 dark:bg-white/5 border-none outline-none focus:ring-2 focus:ring-[#CE010B] font-bold"
                                    value={formData.email} 
                                    onChange={e => setFormData({...formData, email: e.target.value})} 
                                />
                            </div>

                            {/* Teléfono */}
                            <div className="space-y-1">
                                <label className="text-[10px] font-black uppercase text-gray-400 px-1">Teléfono</label>
                                <input 
                                    required 
                                    type="tel" // teclado numérico en móvil
                                    maxLength="10"
                                    className="w-full p-4 rounded-2xl bg-gray-50 dark:bg-white/5 border-none outline-none focus:ring-2 focus:ring-[#CE010B] font-bold"
                                    value={formData.phone} 
                                    onChange={e => setFormData({ ...formData, phone: e.target.value.replace(/\D/g, '') })} 
                                />
                            </div>

                            {/* Licencia */}
                            <div className="space-y-1">
                                <label className="text-[10px] font-black uppercase text-gray-400 px-1">No. Licencia</label>
                                <input 
                                    required 
                                    maxLength="12"
                                    className="w-full p-4 rounded-2xl bg-gray-50 dark:bg-white/5 border-none outline-none focus:ring-2 focus:ring-[#CE010B] font-bold uppercase"
                                    value={formData.license_number.toUpperCase()} 
                                    onChange={e => setFormData({ ...formData, license_number: e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase() })} 
                                />
                            </div>

                            {/* Placas */}
                            <div className="space-y-1">
                                <label className="text-[10px] font-black uppercase text-gray-400 px-1">Placas</label>
                                <input 
                                    required 
                                    maxLength="7"
                                    className="w-full p-4 rounded-2xl bg-gray-50 dark:bg-white/5 border-none outline-none focus:ring-2 focus:ring-[#CE010B] font-bold uppercase"
                                    value={formData.vehicle_plate.toUpperCase()} 
                                    onChange={e => setFormData({ ...formData, vehicle_plate: e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase() })} 
                                />
                            </div>

                            {/* Contraseña - CAMBIO CLAVE: Opcional en edición */}
                            <div className="col-span-2 space-y-1">
                                <label className="text-[10px] font-black uppercase text-gray-400 px-1">
                                    Contraseña de Acceso 
                                    {editingDriver && <span className="text-[#CE010B] lowercase ml-1">(Opcional)</span>}
                                </label>
                                <div className="relative">
                                    <input 
                                        type={showPassword ? "text" : "password"} 
                                        /* Solo es requerido si NO estamos editando */
                                        required={!editingDriver} 
                                        placeholder={editingDriver ? "Dejar en blanco para mantener actual" : "••••••••"}
                                        className="w-full p-4 rounded-2xl bg-gray-50 dark:bg-white/5 border-none outline-none focus:ring-2 focus:ring-[#CE010B] font-bold"
                                        value={formData.password} 
                                        onChange={e => setFormData({...formData, password: e.target.value})} 
                                    />
                                    <button 
                                        type="button" 
                                        onClick={() => setShowPassword(!showPassword)} 
                                        className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#CE010B] transition-colors"
                                    >
                                        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                    </button>
                                </div>
                                <div className="col-span-2 space-y-1">
                                    <label className="text-[10px] font-black uppercase text-gray-400 px-1">
                                        Confirmar Contraseña
                                    </label>
                                    <input 
                                        type="password" 
                                        required={!editingDriver} 
                                        placeholder="Repite la contraseña"
                                        className="w-full p-4 rounded-2xl bg-gray-50 dark:bg-white/5 border-none outline-none focus:ring-2 focus:ring-[#CE010B] font-bold"
                                        value={formData.password_confirmation} 
                                        onChange={e => setFormData({...formData, password_confirmation: e.target.value})} 
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Botón de acción dinámico */}
                        <button 
                            disabled={loading}
                            type="submit" 
                            className="w-full mt-10 bg-[#CE010B] text-white p-5 rounded-[1.5rem] font-black uppercase tracking-[0.2em] shadow-xl hover:shadow-[#CE010B]/20 active:scale-[0.98] transition-all disabled:opacity-50"
                        >
                            {loading 
                                ? "Procesando..." 
                                : (editingDriver ? "Actualizar Datos" : "Finalizar Registro")
                            }
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
};

export default DriversPage;